import formatTableJson from '@kaili/config/tableComponentParams.js'
import { YNColor } from '@kaili/config/StateColorEmun'

export default formatTableJson([
  {
    filed: 'assetNumber',
    label: '设备SN码',
    width: 180
  },
  {
    filed: 'imei',
    label: '设备IMEI'
  },
  {
    filed: 'modelName',
    label: '设备类型'
  },
  {
    filed: 'productModel',
    label: '设备型号'
  },
  {
    filed: 'departmentName',
    label: '负责部门'
  },
  {
    filed: 'shopName',
    label: '门店名称'
  },
  {
    filed: 'shopBindStr',
    label: '门店绑定状态',
    type: 'tag',
    colorList: YNColor,
    width: 140
  },
  {
    filed: 'onlineStr',
    label: '在线状态',
    type: 'tag',
    colorList: YNColor,
    width: 80
  },
  {
    filed: 'appChangeStr',
    label: 'APP参数修改状态',
    type: 'tag',
    colorList: YNColor,
    width: 140
  },
  {
    filed: 'createTime',
    label: '最近参数修改时间',
    width: '170',
    type: 'time'
  }
])
